module.exports = __webpack_public_path__ + "img/75568.790934bf.svg";